import { ModuleWithProviders, NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../shared/shared.module'

import { BaseContainer } from './containers/base-container/base-container.component'
import { OutletComponent } from './components/outlet/outlet.component'
import { HeaderComponent } from './components/header/header.component'
import { SearchBarComponent } from './components/search-bar'
import { CartComponent } from './components/cart/cart.component'
import { FooterComponent } from './components/footer/footer.component'
import { UserMenuComponent } from './components/user-menu/user-menu.component'
import { SiteMenuComponent } from './components/site-menu/site-menu.component'
import { MenuItemComponent } from './components/menu-item/menu-item.component'
import { CategoryMenuComponent } from './components/category-menu/category-menu.component'
import { MenuContentComponent } from './components/menu-content/menu-content.component'

import { MenuButtonDirective } from './directives/menu-button.directive'
import { SideMenuDirective } from './directives/side-menu.directive'

import { reducers } from './reducers'

import { PagesEffects } from './effects/pages.effects'
import { StatusEffects } from './effects/status.effects'

import { PagesService } from './services/pages.service'
import { MenusEffects } from './effects/menus.effects';
import { MenusService } from './services/menus.service';
import { PreferencesService } from './services/preferences.service';
import { PreferencesEffects } from './effects/preferences.effects';

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([])
  ],
  declarations: [
    BaseContainer, 
    OutletComponent,
    HeaderComponent,
    SearchBarComponent,
    CartComponent,
    FooterComponent,
    UserMenuComponent,
    SiteMenuComponent,
    MenuItemComponent,
    CategoryMenuComponent,
    MenuButtonDirective,
    SideMenuDirective,
    MenuContentComponent
  ],
  exports: [BaseContainer]
})
export class BaseModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: RootBaseModule,
      providers: [PagesService, MenusService, PreferencesService]
    }
  }
}

@NgModule({
  imports: [
    BaseModule,
    StoreModule.forFeature('base', reducers),
    EffectsModule.forFeature([PagesEffects, StatusEffects, MenusEffects, PreferencesEffects])
  ],
  exports: [BaseContainer]
})
export class RootBaseModule {

}
